import { AxiosInterceptor } from "api/core/consts";

export const qualityApi = {
  searchQualityWorkOrderLog: (paging, body) =>
    AxiosInterceptor.post('quality/workOrderLog/search' + paging, body),
  getQualityTracking: (workOrderLogId) =>
    AxiosInterceptor.get('quality/tracking/' + workOrderLogId),
};
